import { render, staticRenderFns } from "./App_K1.vue?vue&type=template&id=2d660650&"
import script from "./App_K1.vue?vue&type=script&lang=js&"
export * from "./App_K1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports